/**
 * UnitToggle Component
 *
 * Toggle button for switching between metric and imperial units.
 * Affects display of weight (kg/lbs) and length measurements (cm/inches).
 */

import React from 'react';

export type UnitSystem = 'metric' | 'imperial';

interface UnitToggleProps {
  currentUnit: UnitSystem;
  onToggle: (unit: UnitSystem) => void;
  className?: string;
}

const UnitToggle: React.FC<UnitToggleProps> = ({
  currentUnit,
  onToggle,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-neutral-600">Units:</span>
      <div className="inline-flex rounded-md shadow-sm" role="group">
        <button
          type="button"
          onClick={() => onToggle('metric')}
          className={`px-4 py-2 text-sm font-medium rounded-l-md border transition ${
            currentUnit === 'metric'
              ? 'bg-primary-600 text-white border-primary-600'
              : 'bg-white text-neutral-700 border-neutral-300 hover:bg-neutral-50'
          }`}
        >
          Metric
        </button>
        <button
          type="button"
          onClick={() => onToggle('imperial')}
          className={`px-4 py-2 text-sm font-medium rounded-r-md border-t border-r border-b transition ${
            currentUnit === 'imperial'
              ? 'bg-primary-600 text-white border-primary-600'
              : 'bg-white text-neutral-700 border-neutral-300 hover:bg-neutral-50'
          }`}
        >
          Imperial
        </button>
      </div>
    </div>
  );
};

export default UnitToggle;
